import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function ServiceContractNoteTextarea() {
  return (
    <Field
      type="textarea"
      name="serviceContractNote"
      minRows={3}
      label={i18n.t('entity.vehicle.labels.serviceContractNote')}
    />
  );
}
